/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from "react";
import { Scrollbars } from "react-custom-scrollbars";

const getShortName = (name = "") =>
  name.length > 16 ? `${name.substring(0, 16)}...` : name;

export function CalendarClinicDropdown({
  selectedClinic,
  clinics,
  onChangeClinic,
  buttonClassName = "btn btn-default dropdown-toggle cal-clinic-filter",
  menuClassName = "dropdown-menu cal-dropdown clinicname-dropdown",
  buttonProps = {},
}) {
  return (
    <div className="calClinicdropDown">
      <div className="dropdown pull-left weekDropdowncal">
        <button
          className={buttonClassName}
          type="button"
          data-toggle="dropdown"
          {...buttonProps}
        >
          {getShortName(selectedClinic)}
          <i className="fas fa-angle-down"></i>
        </button>
        <ul className={menuClassName}>
          <Scrollbars
            autoHeight
            autoHeightMin={0}
            autoHeightMax={306}
            className="full-width"
            renderTrackHorizontal={(props) => (
              <div
                {...props}
                style={{ display: "none" }}
                className="track-horizontal"
              />
            )}
          >
            {clinics.length > 0 &&
              clinics.map((clinic, idx) => {
                return (
                  <li
                    key={"clinics-" + idx}
                    data-id={clinic.id}
                    onClick={onChangeClinic}
                  >
                    <a>
                      <label>{clinic.clinic_name}</label>
                    </a>
                  </li>
                );
              })}
          </Scrollbars>
        </ul>
      </div>
    </div>
  );
}
